var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-alert',{staticClass:"hint",class:_vm.colorClass,attrs:{"show":"","timeout":_vm.timeout,"data-cCy":_vm.dataCy},on:{"hidden":_vm.onHidden}},[_c('div',{staticClass:"hint-wrapper"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }